'use client';
import {cn} from '@/lib/utils';
import {useTranslations} from 'next-intl';
import {useState} from 'react';
import PageLayout from '../PageLayout';

export default function NotFoundPage() {
  const t = useTranslations('NotFoundPage');
  const [searchQuery, setSearchQuery] = useState('');

  const search = () => {
    if (searchQuery === '') {
      return;
    }
    window.location.href = '/search?q=' + searchQuery;
  };

  return (
    <PageLayout title={t('title')}>
      <div className="flex flex-col items-center justify-center my-[10vh]">
        <h1 className="text-3xl font-bold my-4 text-[#e22319]">{t('title')}</h1>
        <p className="max-w-[460px]">{t('description')}</p>
        {false && (
          <div className="flex justify-center my-4 items-center gap-2 ">
            <div className="flex justify-center my-4 items-center border border-gray-200 rounded-md p-2">
              <div className="material-symbols outlined">search</div>
              <input
                type="text"
                placeholder={t('search')}
                className="md:w-[20vw] max-w-[400px] pl-2 text-[14px]"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    search();
                  }
                }}
              />
            </div>
            <div
              className={cn(
                'w-10 h-10 rounded-full bg-[#e22319] text-white flex justify-center items-center cursor-pointer hover:opacity-100',
                searchQuery === '' ? 'opacity-50' : 'opacity-90'
              )}
              onClick={search}
            >
              <div className="material-symbols outlined">send</div>
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
}
